import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { configApi, type GlobalConfigInput } from "@/lib/api";
import { queryKeys } from "./keys";

export function useCurrentConfig() {
  return useQuery({
    queryKey: queryKeys.config.current,
    queryFn: configApi.getCurrentConfig,
  });
}

export function useConfigVersions() {
  return useQuery({
    queryKey: queryKeys.config.versions,
    queryFn: configApi.listConfigVersions,
  });
}

export function useUpdateConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: GlobalConfigInput) => configApi.updateConfig(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.config.current });
      void queryClient.invalidateQueries({ queryKey: queryKeys.config.versions });
    },
  });
}

export function useRollbackConfigVersion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (versionId: string) => configApi.rollbackConfigVersion(versionId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.config.current });
      void queryClient.invalidateQueries({ queryKey: queryKeys.config.versions });
    },
  });
}
